import articleCredits from '../img_main/article-credits.png';
import articleCards from '../img_main/article-cards.png';
import articleSecurity from '../img_main/article-security.png';
import catLoansIcon from '../img_main/cat-loans.png';
import catDebitIcon from '../img_main/cat-debit.png';
import catCreditIcon from '../img_main/cat-credit.png';

export const ARTICLE_CATEGORIES = [
  'Все',
  'Кредиты',
  'Карты',
  'Безопасность',
  'Сравнение',
];

export const ARTICLES = [
  {
    slug: 'kak-snizit-stavku-po-kreditu',
    title: 'Как снизить ставку по кредиту: рабочие способы',
    category: 'Кредиты',
    date: '12.07.2026',
    dateISO: '2026-07-12',
    readTime: '7 мин',
    cover: articleCredits,
    excerpt: 'Какие шаги реально помогают получить более выгодные условия и на что смотреть при сравнении предложений.',
    cta: {
      to: '/consumer-loans',
      label: 'Сравнить кредиты',
      text: 'Подберите предложения банков по ставке, сумме и сроку в одном каталоге.',
    },
    toc: [
      { id: 'pochemu-stavka', title: 'От чего зависит ставка' },
      { id: 'sposoby', title: 'Рабочие способы снизить ставку' },
      { id: 'refinans', title: 'Когда помогает рефинансирование' },
      { id: 'checklist', title: 'Краткий чек-лист перед заявкой' },
    ],
    blocks: [
      {
        type: 'p',
        text: 'Ставка по кредиту влияет на переплату сильнее, чем кажется на первый взгляд. Даже разница в несколько процентных пунктов заметно меняет ежемесячный платёж и итоговую стоимость займа.',
      },
      {
        type: 'h2',
        id: 'pochemu-stavka',
        text: 'От чего зависит ставка',
      },
      {
        type: 'p',
        text: 'Банк оценивает риск: кредитную историю, доход, срок, сумму и наличие залога. Чем понятнее ваш профиль и стабильнее доход, тем выше шанс получить более мягкие условия.',
      },
      {
        type: 'p',
        text: 'Также на ставку влияет выбранный продукт: кредит наличными, рефинансирование или кредит под залог. Условия лучше сравнивать не только по «ставке от», но и по полной стоимости кредита.',
      },
      {
        type: 'image',
        src: articleCredits,
        alt: 'Иллюстрация к статье о снижении ставки по кредиту',
      },
      {
        type: 'h2',
        id: 'sposoby',
        text: 'Рабочие способы снизить ставку',
      },
      {
        type: 'ul',
        items: [
          'Сравните несколько предложений до подачи заявки — так проще выбрать подходящий диапазон условий.',
          'Подготовьте документы заранее: паспорт, подтверждение дохода и занятости.',
          'Не запрашивайте сумму больше необходимой — лишний лимит часто повышает риск для банка.',
          'Рассмотрите залог или поручительство, если готовы к таким условиям.',
          'Проверьте кредитную историю и закройте просрочки до обращения.',
        ],
      },
      {
        type: 'h2',
        id: 'refinans',
        text: 'Когда помогает рефинансирование',
      },
      {
        type: 'p',
        text: 'Рефинансирование полезно, если текущая ставка заметно выше рыночной или платежи давят на бюджет. Перед сменой кредита посчитайте комиссии, страховки и срок новой выплаты.',
      },
      {
        type: 'p',
        text: 'Иногда выгоднее не менять банк, а договориться о реструктуризации. Но если на рынке есть более прозрачные условия, имеет смысл сравнить предложения в каталоге.',
      },
      {
        type: 'h2',
        id: 'checklist',
        text: 'Краткий чек-лист перед заявкой',
      },
      {
        type: 'ol',
        items: [
          'Определите комфортный ежемесячный платёж.',
          'Сравните ставку, срок, сумму и дополнительные платежи.',
          'Проверьте, нет ли скрытых комиссий за выдачу или обслуживание.',
          'Подавайте заявку только в те банки, условия которых вам понятны.',
        ],
      },
    ],
  },
  {
    slug: 'keshbek-kak-poluchat-maksimum',
    title: 'Кэшбэк: как получать максимум выгоды каждый день',
    category: 'Карты',
    date: '08.07.2026',
    dateISO: '2026-07-08',
    readTime: '6 мин',
    cover: articleCards,
    excerpt: 'Как выбрать дебетовую карту под свои траты и не потерять выгоду на лимитах и категориях.',
    cta: {
      to: '/cards',
      label: 'Смотреть карты',
      text: 'Сравните кэшбэк, проценты на остаток и стоимость обслуживания.',
    },
    toc: [
      { id: 'kak-rabotaet', title: 'Как устроен кэшбэк' },
      { id: 'vybor', title: 'Как выбрать карту под траты' },
      { id: 'oshibki', title: 'Частые ошибки' },
      { id: 'praktika', title: 'Практические советы' },
    ],
    blocks: [
      {
        type: 'p',
        text: 'Кэшбэк работает только тогда, когда карта совпадает с вашими повседневными тратами. Высокий процент в ненужной категории почти не даёт выгоды, а лимиты легко «съедают» ожидания.',
      },
      {
        type: 'h2',
        id: 'kak-rabotaet',
        text: 'Как устроен кэшбэк',
      },
      {
        type: 'p',
        text: 'Банки возвращают часть суммы покупки рублями, баллами или милями. Важно смотреть не только на процент, но и на максимальный возврат в месяц, список исключений и стоимость обслуживания.',
      },
      {
        type: 'image',
        src: articleCards,
        alt: 'Иллюстрация к статье о кэшбэке',
      },
      {
        type: 'h2',
        id: 'vybor',
        text: 'Как выбрать карту под траты',
      },
      {
        type: 'ul',
        items: [
          'Оцените, куда уходит основная часть расходов: продукты, АЗС, кафе, онлайн.',
          'Сравните лимит кэшбэка в месяц — от него зависит реальная выгода.',
          'Проверьте процент на остаток, если держите деньги на карте.',
          'Уточните условия бесплатного обслуживания.',
        ],
      },
      {
        type: 'h2',
        id: 'oshibki',
        text: 'Частые ошибки',
      },
      {
        type: 'p',
        text: 'Самая распространённая ошибка — ориентироваться только на рекламный процент. Вторая — забывать про категории месяца и тратить мимо повышенного кэшбэка.',
      },
      {
        type: 'h2',
        id: 'praktika',
        text: 'Практические советы',
      },
      {
        type: 'ol',
        items: [
          'Держите одну основную карту для повседневных покупок.',
          'Раз в месяц сверяйте категории и лимиты.',
          'Не открывайте карту ради разовой акции, если обслуживание станет платным.',
          'Сравнивайте предложения в каталоге до оформления.',
        ],
      },
    ],
  },
  {
    slug: 'finansovaya-bezopasnost',
    title: 'Финансовая безопасность: простые правила защиты',
    category: 'Безопасность',
    date: '02.07.2026',
    dateISO: '2026-07-02',
    readTime: '5 мин',
    cover: articleSecurity,
    excerpt: 'Базовые правила, которые помогают защитить счета, карты и персональные данные.',
    cta: {
      to: '/cards',
      label: 'Выбрать карту',
      text: 'Оформляйте продукты только на официальных сайтах банков и сервисов.',
    },
    toc: [
      { id: 'ugrozy', title: 'Основные риски' },
      { id: 'pravila', title: 'Простые правила защиты' },
      { id: 'esli-sluchilos', title: 'Если данные уже скомпрометированы' },
    ],
    blocks: [
      {
        type: 'p',
        text: 'Большинство мошеннических схем строится на спешке и доверии. Если запросить код, перевод или «подтверждение операции» пытаются неожиданно — это уже тревожный сигнал.',
      },
      {
        type: 'h2',
        id: 'ugrozy',
        text: 'Основные риски',
      },
      {
        type: 'ul',
        items: [
          'Фишинговые сайты и поддельные приложения.',
          'Звонки и сообщения от имени банка.',
          'Утечка SMS-кодов и доступов к личному кабинету.',
          'Подозрительные ссылки в мессенджерах и почте.',
        ],
      },
      {
        type: 'image',
        src: articleSecurity,
        alt: 'Иллюстрация к статье о финансовой безопасности',
      },
      {
        type: 'h2',
        id: 'pravila',
        text: 'Простые правила защиты',
      },
      {
        type: 'ol',
        items: [
          'Не сообщайте коды из SMS и push-уведомлений никому.',
          'Входите в банк только через официальное приложение или сайт.',
          'Включайте уведомления по операциям.',
          'Используйте разные пароли для важных сервисов.',
          'Проверяйте адрес сайта перед вводом данных карты.',
        ],
      },
      {
        type: 'h2',
        id: 'esli-sluchilos',
        text: 'Если данные уже скомпрометированы',
      },
      {
        type: 'p',
        text: 'Сразу заблокируйте карту в приложении банка, смените пароли и обратитесь в поддержку. Чем быстрее реакция, тем выше шанс остановить сомнительные операции.',
      },
    ],
  },
  {
    slug: 'kak-sravnit-kreditnye-karty',
    title: 'Как сравнить кредитные карты без путаницы',
    category: 'Карты',
    date: '28.06.2026',
    dateISO: '2026-06-28',
    readTime: '6 мин',
    cover: catCreditIcon,
    excerpt: 'Льготный период, лимит и ставка — разбираем, какие параметры важны при выборе кредитки.',
    cta: {
      to: '/auto-loans',
      label: 'К кредитным картам',
      text: 'Сравните лимиты, льготный период и условия обслуживания.',
    },
    toc: [
      { id: 'parametry', title: 'Ключевые параметры' },
      { id: 'lgotnyi', title: 'Льготный период' },
      { id: 'vybor', title: 'Как выбрать под задачу' },
    ],
    blocks: [
      {
        type: 'p',
        text: 'Кредитная карта удобна как резерв и инструмент для покупок с отсрочкой платежа. Но выгода появляется только при дисциплине: льготный период нужно закрывать вовремя.',
      },
      {
        type: 'h2',
        id: 'parametry',
        text: 'Ключевые параметры',
      },
      {
        type: 'ul',
        items: [
          'Кредитный лимит и правила его изменения.',
          'Длина и условия льготного периода.',
          'Ставка после льготного периода.',
          'Комиссии за снятие наличных и переводы.',
          'Стоимость обслуживания и обязательные сервисы.',
        ],
      },
      {
        type: 'image',
        src: catCreditIcon,
        alt: 'Иллюстрация к статье о кредитных картах',
      },
      {
        type: 'h2',
        id: 'lgotnyi',
        text: 'Льготный период',
      },
      {
        type: 'p',
        text: 'Смотрите не только на число дней, но и на то, какие операции входят в льготный период. Снятие наличных часто считается отдельно и сразу становится дорогим.',
      },
      {
        type: 'h2',
        id: 'vybor',
        text: 'Как выбрать под задачу',
      },
      {
        type: 'p',
        text: 'Если нужна рассрочка — сравнивайте карты с прозрачным графиком. Если нужен запас на крупные покупки — важнее лимит и понятная ставка после грейса.',
      },
    ],
  },
  {
    slug: 'potrebitelskii-kredit-na-chto-smotret',
    title: 'Потребительский кредит: на что смотреть перед заявкой',
    category: 'Кредиты',
    date: '20.06.2026',
    dateISO: '2026-06-20',
    readTime: '8 мин',
    cover: catLoansIcon,
    excerpt: 'Ставка, срок, платёж и дополнительные условия — короткий разбор перед оформлением кредита наличными.',
    cta: {
      to: '/consumer-loans',
      label: 'Сравнить предложения',
      text: 'Посмотрите актуальные условия по кредитам наличными и рефинансированию.',
    },
    toc: [
      { id: 'baza', title: 'Базовые условия' },
      { id: 'pereplata', title: 'Как оценить переплату' },
      { id: 'dokumenty', title: 'Документы и проверка' },
    ],
    blocks: [
      {
        type: 'p',
        text: 'Потребительский кредит подходит, когда нужна крупная сумма на понятный срок. Перед заявкой важно заранее понять комфортный платёж и сравнить несколько банков.',
      },
      {
        type: 'h2',
        id: 'baza',
        text: 'Базовые условия',
      },
      {
        type: 'p',
        text: 'Сравнивайте ставку, сумму, срок и требования к заёмщику. Обращайте внимание на страховки и комиссии: они могут заметно изменить итоговую стоимость.',
      },
      {
        type: 'image',
        src: catLoansIcon,
        alt: 'Иллюстрация к статье о потребительском кредите',
      },
      {
        type: 'h2',
        id: 'pereplata',
        text: 'Как оценить переплату',
      },
      {
        type: 'p',
        text: 'Посчитайте ежемесячный платёж и общую сумму выплат. Если два предложения похожи по ставке, выигрывает то, где меньше обязательных доплат и понятнее досрочное погашение.',
      },
      {
        type: 'h2',
        id: 'dokumenty',
        text: 'Документы и проверка',
      },
      {
        type: 'ul',
        items: [
          'Паспорт и подтверждение дохода.',
          'Актуальные контакты и место работы.',
          'Понимание цели кредита и желаемого срока.',
        ],
      },
    ],
  },
  {
    slug: 'debitovaya-karta-dlya-povsednevnyh-trat',
    title: 'Дебетовая карта для повседневных трат: как выбрать',
    category: 'Сравнение',
    date: '14.06.2026',
    dateISO: '2026-06-14',
    readTime: '5 мин',
    cover: catDebitIcon,
    excerpt: 'Короткий гид: обслуживание, кэшбэк, снятие наличных и переводы без лишней сложности.',
    cta: {
      to: '/cards',
      label: 'К дебетовым картам',
      text: 'Выберите карту под свои задачи и оформите онлайн.',
    },
    toc: [
      { id: 'kriterii', title: 'Критерии выбора' },
      { id: 'kogda-menyat', title: 'Когда стоит менять карту' },
    ],
    blocks: [
      {
        type: 'p',
        text: 'Удачная дебетовая карта экономит деньги незаметно: на обслуживании, переводах и повседневном кэшбэке. Главное — выбрать критерии под свой сценарий использования.',
      },
      {
        type: 'h2',
        id: 'kriterii',
        text: 'Критерии выбора',
      },
      {
        type: 'ul',
        items: [
          'Бесплатное или условно бесплатное обслуживание.',
          'Понятный кэшбэк без сложных механик.',
          'Удобное снятие наличных и переводы.',
          'Надёжное приложение и быстрая поддержка.',
        ],
      },
      {
        type: 'image',
        src: catDebitIcon,
        alt: 'Иллюстрация к статье о дебетовых картах',
      },
      {
        type: 'h2',
        id: 'kogda-menyat',
        text: 'Когда стоит менять карту',
      },
      {
        type: 'p',
        text: 'Если обслуживание стало платным, кэшбэк перестал совпадать с тратами или появились более выгодные условия в другом банке — сравните предложения и перенесите основные операции.',
      },
    ],
  },
];

const bySlug = new Map(ARTICLES.map((article) => [article.slug, article]));

export const getArticleBySlug = (slug) => bySlug.get(slug) || null;

export const getRelatedArticles = (article, limit = 3) => {
  if (!article) return [];
  const sameCategory = ARTICLES.filter(
    (item) => item.slug !== article.slug && item.category === article.category
  );
  const others = ARTICLES.filter(
    (item) => item.slug !== article.slug && item.category !== article.category
  );
  return [...sameCategory, ...others].slice(0, limit);
};
